import { ref as c } from "vue";
const p = 50;
function M(s, i) {
  let n, e = !1;
  const t = c(!1);
  function r(o) {
    n = o.clientX, t.value = !0;
  }
  function a(o) {
    if (e || !t.value)
      return;
    const l = o.clientX, u = n - l;
    u > p ? (e = !0, s()) : u < -50 && (e = !0, i());
  }
  function f() {
    n = 0, e = !1, t.value = !1;
  }
  return {
    onMouseDown: r,
    onMouseMove: a,
    onMouseUp: f,
    isGrabbing: t
  };
}
export {
  M as useMouseNavigation
};
